import { Store } from "react-notifications-component";

const notifications = (message: any) => {
  Store.addNotification({
    title: message?.title,
    message: message?.message,
    type: message?.type,
    insert: "top",
    container: "center",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      // Errors and warnings stay long enough to read on a phone; "Saved" can go quickly.
      duration: message?.duration || (message?.type === "danger" ? 5000 : message?.type === "warning" ? 4000 : 2000),
      onScreen: true,
    },
  });
  return null;
};

export default notifications;
